import { generateUrl } from '@/internal/utils/generate-url'
import { resolvePctLinkUrl } from '@/internal/utils/resolve-pctlink-url'

export function resolveCtaUrl(
  cta: Queries.CtaFragment,
  absolute = false
): string {
  const { ctaType, link, linkMedia, linkContent } = cta

  if (ctaType === 'url') {
    return link ?? ''
  }
  if (ctaType === 'asset') {
    return linkMedia?.url ?? ''
  }
  if (ctaType === 'content' && linkContent) {
    const slug = 'slug' in linkContent ? linkContent?.slug : ''

    if (linkContent.__typename === 'DatoCmsPctLink') {
      return resolvePctLinkUrl(linkContent, absolute)
    }

    return generateUrl(linkContent.__typename, slug ?? '', absolute)
  }
  return ''
}
